<section class="breadcrumbs_common bg_img pos_relative">
    <div class="overlay-innerpage"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumbs_content">
                    <h2 class="text-white">Contact</h2>
                    <ul class="breadcrumb">
                        <li>
                            <a routerLink="/">Home</a>
                        </li>/
                        <li class="active">
                            <a href="javascript:void(0);">Contact</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
<hr>
<section class="contact ptb--100">
    <div class="container">
        <div class="row justify-content-center g-lg-5 align-items-center gy-4">
            <div class="col-lg-6 ">
                <div class="contact-form effect8">
                    <div class="npf_wgts" data-height="480px" data-w="6d304e2e2cfdd5a0de90fc360591677e"></div>

                    <!-- <div class="npf_wgts" data-height="480px" data-w="6e2d938a8f42987637737ee22606670f"></div> -->
                    <!-- <form [formGroup]="registerForm" (ngSubmit)="submitForm()" method="post">
                        <div class="row gy-3">
                            <div class="col-md-6">
                                <input type="text" placeholder="Name" formControlName="name" name="name" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.name.errors }">
                                <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                    <div *ngIf="f.name.errors.required">Name is required</div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <input type="email" placeholder="Email" formControlName="email" name="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                    <div *ngIf="f.email.errors.required">Email is required</div>
                                    <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <input type="text" placeholder="Phone" formControlName="phone" name="phone" class="form-control" title="please enter a valid phone number" pattern="^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$" minlength="10" maxlength="10"  [ngClass]="{ 'is-invalid': submitted && f.phone.errors }">
                                <div *ngIf="submitted && f.phone.errors" class="invalid-feedback">
                                    <div *ngIf="f.phone.errors.required">Mobile Number is required.</div>
                                    <div *ngIf="f.phone.errors.pattern">Please, Enter 10 digit Mobile Number.</div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <input type="text" placeholder="Subject" formControlName="subject" class="form-control" name="subject">
                            </div>
                            <div class="col-md-12">
                                <textarea formControlName="message" id="#" cols="30" rows="6" placeholder="Message" class="form-control" name="message"></textarea>

                            </div>
                            <div class="col-md-12">
                                <button class="cmn-button" type="submit" name="submit">Send message</button>
                            </div>
                        </div>
                    </form> -->
                </div>
            </div>
            <div class="col-lg-5">
                <div class="contact-info">
                    <div class="icon">
                        <i class="fa fa-map-marker"></i>
                    </div>
                    <div class="details">
                        <a href="javascript:void(0);" class="text-dark">
                            GHRCACS 'D' building, Domkhel road, Gate No. 1200 Wagholi, Pune – 412207.</a>
                    </div>
                </div>
                <div class="contact-info">
                    <div class="icon">
                        <i class="fa fa-phone"></i>
                    </div>
                    <div class="details">
                        <a href="tel:8669950061" class="text-dark"><span>IQAC
                                Coordinator-&nbsp;</span>+91-8669950061</a><br>
                        <a href="tel:#" class="text-dark"><span>For Admission Inquiry: </span>8605625522/7720088580/
                            7720089274/7720089275</a>

                    </div>
                </div>
                <div class="contact-info">
                    <div class="icon">
                        <i class="fa fa-envelope-o"></i>
                    </div>
                    <div class="details">
                        <a href="mailto:ghrcacs.pune@raisoni.net" class="text-dark">ghrcacs.pune@raisoni.net</a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
<section class="section-sm">
    <div class="container">
        <div class="col-12">
            <div class="sec-title">
                <h2>Raisoni Group Admission <span> Incharge </span></h2>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered example display nowrap table--1">

                    <thead>
                        <tr>
                            <th>Location</th>
                            <th>Admission Incharge</th>
                            <th>Contact Number</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Admission cell, Nagpur</td>
                            <td>Mrs. Nidhi Kurda</td>
                            <td><a href="tel:9307900682">9307900682</a></td>
                        </tr>

                        <tr>
                            <td>Admission cell, Nagpur</td>
                            <td>Mr. Dhammadip Shingade</td>
                            <td><a href="tel:8975862424">8975862424</a></td>
                        </tr>
                        <tr>
                            <td>Admission cell, Nagpur</td>
                            <td>Mr. Samyak Raj </td>
                            <td><a href="tel:9307900681">9307900681</a></td>
                        </tr>
                        <tr>
                            <td>Admission cell, GHRU, Saikheda</td>
                            <td>Prof. Adheer A.Goyal</td>
                            <td><a href="tel:8446640020">8446640020</a></td>
                        </tr>
                        <tr>
                            <td>Admission cell, GHRU, Saikheda</td>
                            <td>Mr. Bharat Bhargava</td>
                            <td><a href="tel:9860454944">9860454944</a></td>
                        </tr>
                        <!-- <tr>
                      <td>Admission cell,GHRU, Amravati</td>
                      <td>Mr. Manish Awasthi</td>
                      <td><a href="tel:9657724126">9657724126</a></td>
                  </tr> -->
                        <tr>
                            <td>Admission cell,GHRU, Amravati</td>
                            <td>Mr. Kishor Watane</td>
                            <td><a href="tel:9422377963">9422377963</a></td>
                        </tr>
                        <tr>
                            <td>Admission cell,GHRU, Amravati</td>
                            <td>Mr. Pavan Ambulkar</td>
                            <td><a href="tel:7391079473">7391079473</a></td>
                        </tr>
                        <tr>
                            <td>Admission cell, Jalgaon</td>
                            <td>Mr. Rafik Shaikh / Tanmay Bhale </td>
                            <td><a href="tel:9823337862">9823337862</a> / <a href="tel:9657724083">9657724083</a></td>
                        </tr>
                        <!-- <tr>
                      <td>Admission cell, Jalgaon</td>
                      <td>Mr. Ganesh Patil</td>
                      <td><a href="tel:9623450636">9623450636</a></td>
                  </tr> -->
                        <tr>
                            <td>Admission cell, Pune</td>
                            <td>Ms. Amita Singh</td>
                            <td><a href="tel:8605625522">8605625522</a></td>
                        </tr>
                        <tr>
                            <td>Admission Cell,Junior Colleges (State & Cbse)</td>
                            <td>Mr. Amandeep Singh Rajput </td>
                            <td><a href="tel:9552991973">9552991973</a></td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>

    </div>
</section>
<section class="section-sm">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="sec-title">
                    <h2>City <span> Offices</span></h2>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered example display nowrap table--1">
                      <thead>
                        <tr>
                        <th class="text-center" colspan="7">CITY OFFICE ACTIVE EMPLOYEES</th>
                        </tr>
                        <tr>
                        <th>SR. NO.</th>
                        <th>EXECUTIVE NAME</th>
                        <th>CITY</th>
                        <th>DESIGNATION</th>
                        <th>CONTACT</th>
                        <th>ADDRESS</th>
                        <th>EMAIL</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                        <td>1</td>
                        <td>Rajwardhan Damodar / Chetan Gawai</td>
                        <td>Akola</td>
                        <td>Sr. Academic Counsellor</td>
                        <td>
                            <a href="tel:7391098119">7391098119</a> /
                            <a href="tel:9403172285">9403172285</a>
                        </td>
                        <td>Near Gajanan Hospital, Int. of Sharda Udyog ( Necklace Road), Akola-444001</td>
                        <td>
                            <a href="mailto:rajwardhan.damodar@raisoni.net">rajwardhan.damodar@raisoni.net</a> /
                            <a href="mailto:chetan.gawai@raisoni.net">chetan.gawai@raisoni.net</a>
                        </td>
                        </tr>
                        <tr>
                        <td>2</td>
                        <td>Sandesh Jadhao</td>
                        <td>Buldhana</td>
                        <td>Sr. Academic Counsellor</td>
                        <td><a href="tel:7391079436">7391079436</a></td>
                        <td>Raut mangal karyalaya, Infront of Bal Shivaji school, Circular road, Buldhana 443001</td>
                        <td><a href="mailto:sandesh.jadhav@raisoni.net">sandesh.jadhav@raisoni.net</a></td>
                        </tr>
                        <tr>
                        <td>3</td>
                        <td>Rakesh Rakhade / Shoeb Pathan</td>
                        <td>Bhandara</td>
                        <td>Sr. Academic Counsellor</td>
                        <td>
                            <a href="tel:7391079434">7391079434</a> /
                            <a href="tel:7249464677">7249464677</a>
                        </td>
                        <td>Raisoni Education, 2nd Floor,Vijaylaxmi Building,Bikaner Road,Tuition Galli,Rajiv Gandhi Chowk,Bhandara</td>
                        <td><a href="mailto:rakesh.rakhade@raisoni.net">rakesh.rakhade@raisoni.net</a></td>
                        </tr>
                        <tr>
                        <td>4</td>
                        <td>Rahul Zanke / Karan Borewar</td>
                        <td>Chandrapur</td>
                        <td>Sr. Academic Counsellor</td>
                        <td>
                            <a href="tel:7391079440">7391079440</a> /
                            <a href="tel:7030252767">7030252767</a>
                        </td>
                        <td>Raisoni Education, Sai Heritage, 2nd Floor, beside karmachari patsanstha office, Warora Naka, Chandrapur</td>
                        <td>
                            <a href="mailto:rahul.zanke@raisoni.net">rahul.zanke@raisoni.net</a> /
                            <a href="mailto:karan.borewar@raisoni.net">karan.borewar@raisoni.net</a>
                        </td>
                        </tr>
                        <tr>
                        <td>5</td>
                        <td>Hitesh Bhele / Siddhant Moon</td>
                        <td rowspan="2">Wardha</td>
                        <td>Sr. Academic Counsellor</td>
                        <td>
                            <a href="tel:7030246781">7030246781</a> /
                            <a href="tel:7391049948">7391049948</a>
                        </td>
                        <td rowspan="2">Raisoni Education, 1st Floor, Shivarpan complex, Arvi naka, Wardha</td>
                        <td>
                            <a href="mailto:hitesh.bhele@raisoni.net">hitesh.bhele@raisoni.net</a> /
                            <a href="mailto:siddhant.moon@raisoni.net">siddhant.moon@raisoni.net</a>
                        </td>
                        </tr>
                        <tr>
                        <td>6</td>
                        <td>Sanchita Mohod</td>
                        <td>Jr. Counsellor</td>
                        <td><a href="tel:9284372278">9284372278</a></td>
                        <td></td>
                        </tr>
                        <tr>
                        <td>7</td>
                        <td>Pankaj Badoley</td>
                        <td>Gadchiroli</td>
                        <td>Sr. Academic Counsellor</td>
                        <td><a href="tel:7030246798">7030246798</a></td>
                        <td>Raisoni Education,1st floor of Tathagat Automobile, Near Canara Bank, Chamorshi Road, Gadchiroli</td>
                        <td>
                            <a href="mailto:pankaj.badoley@raisoni.net">pankaj.badoley@raisoni.net</a> /
                            <a href="mailto:sachin.shedmake@raisoni.net">sachin.shedmake@raisoni.net</a>
                        </td>
                        </tr>
                        <tr>
                        <td>8</td>
                        <td>Raj Dahiwade</td>
                        <td>Yavatmal</td>
                        <td>Sr. Academic Counsellor</td>
                        <td><a href="tel:7030252726">7030252726</a></td>
                        <td>C/O of Aarya Finical Super Bajar Complex, Near Shiv Shakti Lawn, Dhanmangaon road Yavatmal - 445001</td>
                        <td><a href="mailto:rajesh.dahiwade@raisoni.net">rajesh.dahiwade@raisoni.net</a></td>
                        </tr>
                        <tr>
                        <td>9</td>
                        <td>Mohan Biyani / Danish khan</td>
                        <td>Washim</td>
                        <td>Sr. Academic Counsellor</td>
                        <td>
                            <a href="tel:7030246796">7030246796</a> /
                            <a href="tel:7030058760">7030058760</a>
                        </td>
                        <td>Paras Plaza No 1, Shop No 8, Below HDFC Bank, Risod Road, Washim 444505</td>
                        <td>
                            <a href="mailto:mohan.biyani@raisoni.net">mohan.biyani@raisoni.net</a> /
                            <a href="mailto:danish.khan@raisoni.net">danish.khan@raisoni.net</a>
                        </td>
                        </tr>
                        <tr>
                        <td>10</td>
                        <td>Swapnil Sahare / Gajendra Dhupe</td>
                        <td>Gondia</td>
                        <td>Sr. Academic Counsellor</td>
                        <td>
                            <a href="tel:7875502673">7875502673</a> /
                            <a href="tel:7066042935">7066042935</a>
                        </td>
                        <td>Raisoni Education, 1st floor, Shri Sai Complex, Near New Bus Stand, Balaghat Road, Marartoli, Gondia</td>
                        <td><a href="mailto:swapnil.sahare@raisoni.net">swapnil.sahare@raisoni.net</a></td>
                        </tr>
                        <tr>
                        <td>11</td>
                        <td>Shubham Gupta</td>
                        <td>Warud ( Amravati )</td>
                        <td>Academic Counsellor</td>
                        <td><a href="tel:7498919242">7498919242</a></td>
                        <td>Shop Number 5, Tuljai Complex, Near Kasikar Hospital,Renuka Nagar ,Warud-444906</td>
                        <td><a href="mailto:shubham.gupta@ghrua.edu.in">shubham.gupta@ghrua.edu.in</a></td>
                        </tr>
                        <tr>
                        <td>12</td>
                        <td>Prathamesh Bhusari</td>
                        <td>Paratwada ( Amravati )</td>
                        <td>Academic Counsellor</td>
                        <td><a href="tel:7767004719">7767004719</a></td>
                        <td>Shop No. 9, Gulhane Complex,Near Kamal Agrawal Hospital,Achalpur Road, Paratwada 444805</td>
                        <td><a href="mailto:prathamesh.bhusari@ghrua.edu.in">prathamesh.bhusari@ghrua.edu.in</a></td>
                        </tr>
                        <tr>
                        <td>13</td>
                        <td>Niranjan Raghuwanshi</td>
                        <td>Chhindwara</td>
                        <td>Sr. Academic Counsellor</td>
                        <td><a href="tel:7391079435">7391079435</a></td>
                        <td>Raisoni Education Shop No. M -3 (Mazanine Floor) of Building known as “ Mansarover Commercial Complex,Near Bus stand , Chhindwara (M.P).</td>
                        <td><a href="mailto:niranjan.raghuwanshi@raisoni.net">niranjan.raghuwanshi@raisoni.net</a></td>
                        </tr>
                        <tr>
                        <td>14</td>
                        <td>Devilal Pawar</td>
                        <td>Pandhurna</td>
                        <td>Sr. Academic Counsellor</td>
                        <td><a href="tel:7391079441">7391079441</a></td>
                        <td>Kekatpure Complex, Beside Punjab National Bank, infront of Rest House, Pandhurna</td>
                        <td><a href="mailto:devilal.pawar@raisoni.net">devilal.pawar@raisoni.net</a></td>
                        </tr>
                        <tr>
                        <td>15</td>
                        <td>Manmohan Gire</td>
                        <td>Sausar</td>
                        <td>Sr. Academic Counsellor</td>
                        <td><a href="tel:7828908733">7828908733</a></td>
                        <td>Gawandhe Complex , Near Sai mandir, beside Indian Furniture , Sausar</td>
                        <td><a href="mailto:manmohan.gire@raisoni.net">manmohan.gire@raisoni.net</a></td>
                        </tr>
                        <tr>
                        <td>16</td>
                        <td>Mangalmurti Kanathe</td>
                        <td>Betul</td>
                        <td>Sr. Academic Counsellor</td>
                        <td><a href="tel:7030246785">7030246785</a></td>
                        <td>-</td>
                        <td><a href="mailto:mangalmurti.kanathe@raisoni.net">mangalmurti.kanathe@raisoni.net</a></td>
                        </tr>
                        <tr>
                        <td>17</td>
                        <td>Mohan Bavistale</td>
                        <td>Balaghat</td>
                        <td>Sr. Academic Counsellor</td>
                        <td><a href="tel:7030246854">7030246854</a></td>
                        <td>-</td>
                        <td><a href="mailto:mohan.bavistale@raisoni.net">mohan.bavistale@raisoni.net</a></td>
                        </tr>
                        <tr>
                        <td>18</td>
                        <td>BHARAT PATIL</td>
                        <td>Dhule</td>
                        <td>Sr. Academic Counsellor</td>
                        <td><a href="tel:7030093216">7030093216</a></td>
                        <td>Shop No. 4, Navakar Dreams, Sharda Nagar, Bhoi Society, opp SBI ATM, Swaminarayan Road, Dattamandir,&nbsp;Dhule&nbsp;-&nbsp;424002</td>
                        <td><a href="mailto:bharat.patil@raisoni.net">bharat.patil@raisoni.net</a></td>
                        </tr>
                        <tr>
                        <td>19</td>
                        <td>Shaikh Ateeque&nbsp;Ur&nbsp;Rehman / Vijay Dabade</td>
                        <td>Aurangabad</td>
                        <td>Sr. Academic Counsellor</td>
                        <td>
                            <a href="tel:7030065979">7030065979</a> /
                            <a href="tel:7030252697">7030252697</a>
                        </td>
                        <td>Raisoni Education, plot no 10, sushil Co-Opp Housing Society, Shreya Nagar Road, Osmanpura Aurangabad- 431005 (Land mark : Vaidya Children Hospital Osmanpura Aurangabad)</td>
                        <td>
                            <a href="mailto:ateeque.shaikh@raisoni.net">ateeque.shaikh@raisoni.net</a> /
                            <a href="mailto:vijay.dabhade@raisoni.net">vijay.dabhade@raisoni.net</a>
                        </td>
                        </tr>
                        <tr>
                        <td>20</td>
                        <td>Ramjan mulla</td>
                        <td>Kolhapur</td>
                        <td>Sr. Academic Counsellor</td>
                        <td><a href="tel:7030007494">7030007494</a></td>
                        <td>Raisoni Education,NEAR PURANDAR MISAL RAJARAMPURI 7TH LANE KOLHAPUR MH-416001</td>
                        <td><a href="mailto:ramjan.mulla@raisoni.net">ramjan.mulla@raisoni.net</a></td>
                        </tr>
                        <tr>
                        <td>21</td>
                        <td>Rahul Jagtap</td>
                        <td>Beed</td>
                        <td>Sr. Academic Counsellor</td>
                        <td>
                            <a href="tel:7030057095">7030057095</a> /
                            <a href="tel:7391043285">7391043285</a>
                        </td>
                        <td>Raisoni Education,GALA NO 22 UMAKIRAN COMPLEX PANGIRI ROAD SHAHUNAGAR BEED MH-431122</td>
                        <td><a href="mailto:rahul.jagtap@raisoni.net">rahul.jagtap@raisoni.net</a></td>
                        </tr>
                        <tr>
                        <td>22</td>
                        <td>Akshay Harangulka / Nisar Tamboli</td>
                        <td>Latur</td>
                        <td>Sr. Academic Counsellor</td>
                        <td>
                            <a href="tel:7767003604">7767003604</a> /
                            <a href="tel:7030055780">7030055780</a>
                        </td>
                        <td>Ward no.﻿D1,﻿Milkat Kramank 1470, Ambajogai Road,﻿Venkatesh Nagar, opposite Amba Hanuman Mandir,&nbsp;Latur-413512</td>
                        <td>
                            <a href="mailto:akshay.harangulkar@raisoni.net">akshay.harangulkar@raisoni.net</a> /
                            <a href="mailto:nisar.tamboli@raisoni.net">nisar.tamboli@raisoni.net</a>
                        </td>
                        </tr>
                        <tr>
                        <td>23</td>
                        <td>Santosh Tawade / Harshad Gautam Gaware</td>
                        <td>Nanded</td>
                        <td>Sr. Academic Counsellor</td>
                        <td>
                            <a href="tel:7030246831">7030246831</a> /
                            <a href="tel:7391043280">7391043280</a>
                        </td>
                        <td>SHOP NO2 UDAY NAGAR NEAR TALWARE MATHEMATIC CLASSES BHAGYA NAGAR T POINT NANDED 431602</td>
                        <td>
                            <a href="mailto:santosh.tawade@raisoni.net">santosh.tawade@raisoni.net</a> /
                            <a href="mailto:harshad.gaware@raisoni.net">harshad.gaware@raisoni.net</a>
                        </td>
                        </tr>
                        <tr>
                        <td>24</td>
                        <td>Samyak Raj</td>
                        <td>Ahmednagar</td>
                        <td>Sr. Academic Counsellor</td>
                        <td><a href="tel:8287810035">8287810035</a></td>
                        <td>G H Raisoni College of Engineering And Management Ahmednagar,Gate No.1030, Pune Highway, Village Chass, Jilha Parishad, Ahilya Nagar, Maharashtra 414008</td>
                        <td><a href="mailto:samyak.raj@raisoni.net">samyak.raj@raisoni.net</a></td>
                        </tr>
                        <tr>
                        <td>25</td>
                        <td>Deepak shinde</td>
                        <td>Parbhani</td>
                        <td>Sr. Academic Counsellor</td>
                        <td><a href="tel:7030054936">7030054936</a></td>
                        <td>Raisoni Education, Pimplwadi road Near water tank Hotel Sun and Sand, Parbhani</td>
                        <td><a href="mailto:deepak.shinde@raisoni.net">deepak.shinde@raisoni.net</a></td>
                        </tr>
                        <tr>
                        <td>26</td>
                        <td>Pratiksha Dhanvijay</td>
                        <td>Jalgaon</td>
                        <td>Sr. Academic Counsellor</td>
                        <td><a href="tel:9890743822">9890743822</a></td>
                        <td>Ground floor, Anand Nagar Society, Behind Hotel Royal Palace, Near Zilla Parishad School, Ring Road, Jalgaon-425001</td>
                        <td><a href="mailto:pratiksha.dhanvijay@raisoni.net">pratiksha.dhanvijay@raisoni.net</a></td>
                        </tr>
                      </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <div class="container-fluid">
        <div class="row">
            <div class="col p-0">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.009091102153!2d73.97884031420494!3d18.573628872398523!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c39d5c9aa7e9%3A0xdc562ef591eed71!2sduniyadari%20Katta!5e0!3m2!1sen!2sin!4v1628161929003!5m2!1sen!2sin"
                    width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
            </div>
        </div>
    </div>
</section>
